import clearLocalStorage from '../lib/clear-local-storage';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import refreshTween from "../lib/refreshTween";

gsap.registerPlugin(ScrollTrigger);
export default function init() {

    // Add class after first paint to avoid triggering transitions during initial layout
    const setReady = () => {
        requestAnimationFrame(() => {
            requestAnimationFrame(() => {
                document.documentElement.classList.add('is-ready');
            });
        });
    };

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', setReady, { once: true });
    } else {
        // DOM already parsed
        setReady();
    }

    // Clear filters safely
    (() => {
        const el = document.querySelector('[data-postype]');
        const localStoragePostType = localStorage.getItem('postType');
        const currentPostType = el?.dataset?.postype || null;

        if (!currentPostType || currentPostType !== localStoragePostType) clearLocalStorage();
    })();

    //Anchors
    const siteHeader = document.querySelector("#site-header");
    const links = document.querySelectorAll("a");
    const currentUrl = window.location.origin + window.location.pathname;

    links.forEach((link) => {
        link.addEventListener("click", (event) => {
            const targetUrl = link.getAttribute("href");
            const targetHash = targetUrl.includes("#") ? targetUrl.split("#")[1] : null;

            if (!targetUrl || !targetHash) return;

            const isSamePage = targetUrl.startsWith("#") || targetUrl.startsWith(currentUrl + "#");

            if (link.getAttribute("target") === "_blank") return;

            event.preventDefault();

            setTimeout(() => {
                if (!isSamePage) {
                    window.location.href = targetUrl;
                } else {
                    const targetElement = document.getElementById(targetHash);
                    if (targetElement) {
                        gsap.to(window, {
                            duration: 1.5,
                            scrollTo: { y: targetElement, offsetY: siteHeader?.offsetHeight || 0 },
                            ease: "power2.inOut",
                        });
                    }
                }
            }, siteHeader.classList.contains("opened") ? 1500 : 0);
        });
    });

    document.querySelectorAll('section').forEach((section) => {
        const tl = gsap.timeline({
            scrollTrigger: {
                trigger: section,
                start: 'top 84%',
                once: true,
                onEnter() {
                    section.classList.add('scrolled');
                },
            },
        });
        refreshTween([tl]);
    });
}
